import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Box,
  Image,
  Spinner,
  Checkbox,
} from "@chakra-ui/react";
import thelogo from "../../../assets/thelogo.png"
import { getFollowingUsers } from "../../../pages/dashboard/discover/service";

const RemoveMembersModal = ({ isOpen, onClose, authUserId, groupData, myMembers, handleRemoveMember, handleRemoveSingleMember }) => {
  //sconsole.log("userid-->", authUserId);

  const [allFollowers, setAllFollowers] = useState([]); //unused
  const [loading, setLoading] = useState(true); //unused
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedSingleUser, setSelectedSingleUser] = useState([]);

  const containerBgColor = useColorModeValue("#fff", "#000216");
  const inputBgColor = useColorModeValue("#F9FAFC", "rgba(6, 119, 232, 0.2)"); 

  const inputStyles = {
    p: "5px",
    borderRadius: "5px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    color: "rgba(6, 119, 232, 1)",
    w: "15%",
    //color: "#697C94",
    // h: "2em"
  };

  const btnStyle = {
    p: "5px 10px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
    w: "30%",
  };

  // Create a function to handle checkbox changes
  // const handleCheckboxChange = (userId) => {
  //   if (selectedUsers.includes(userId)) {
  //     // If the user is already selected, remove them
  //     setSelectedUsers(selectedUsers.filter((id) => id !== userId));
  //   } else {
  //     // If the user is not selected, add them
  //     setSelectedUsers([...selectedUsers, userId]);
  //   }

  // };

  // const handleCheckboxChange1 = (userId) => {
  //   const newSelectedUsers = [...selectedUsers]; // Create a copy of the selectedUsers array
  
  //   if (newSelectedUsers.includes(userId)) {
  //     // If the user is already selected, remove them
  //     const index = newSelectedUsers.indexOf(userId);
  //     if (index !== -1) {
  //       newSelectedUsers.splice(index, 1);
  //     }
  //   } else {
  //     // If the user is not selected, add them
  //     newSelectedUsers.push(userId);
  //   }
  
  //   setSelectedUsers(newSelectedUsers);
  // };

  const handleCheckboxChange = (userId) => {
    setSelectedUsers((prevSelectedUsers) => {
      if (prevSelectedUsers.includes(userId)) {
        return prevSelectedUsers.filter((id) => id !== userId);
      } else {
        return [...prevSelectedUsers, userId];
      }
    });
  };
  

  const handleMultipleUsers = (selectedUsers) => {
    const stringSelectedUsers = selectedUsers.map(String); // Convert numeric IDs to strings ['1','2']
    handleRemoveMember(stringSelectedUsers)
  };

  // const handleSingleUser = (userId) => {
  //   // Create a new array with just the userId
  //   const newSelectedUsers = [userId];
  //   const stringSelectedUsers = newSelectedUsers.map(String);
  //   //console.log('stringSelectedUsers: ', stringSelectedUsers)
  //   handleRemoveMember(stringSelectedUsers)
  // };

  const handleSingleUser = (userId) => {
    handleRemoveSingleMember(userId)
  };

  return (
    <>
    
    <Modal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside">
      
        <ModalOverlay />
        <ModalContent bg={containerBgColor}>
          <ModalHeader>
            
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          <Flex justifyContent="center" alignItems="center" mb={"2em"}>
            <Heading fontSize={"1.5em"}>Remove members from {groupData?.name}</Heading>
          </Flex>
          
          {myMembers?.length > 0 ? 
          (myMembers?.map((user, index) => (
            <Flex justifyContent="space-between" alignItems="center" mb={"2em"} key={index}>
                <Stack>
                {/* Content for the left side */}
                {/* <Checkbox
                    value={user?.id}
                    onChange={() => handleCheckboxChange(user?.id)} // Handle checkbox change
                    isChecked={selectedUsers.includes(user?.id)} // Check if the checkbox is checked
                > */}
                    <Flex alignItems="center">
                
                        <Image
                            fallbackSrc={thelogo} // Provide a fallback image source
                            src={user?.picture} // Replace with the actual image source
                            alt={user?.name} // Replace with the actual alt text
                            boxSize="50px"
                            borderRadius="50%"
                        />
                        <Text ml="2">{user?.name}</Text>
                
                    </Flex>
                {/* </Checkbox> */}
                </Stack>

                <Box
                    textAlign={"center"}
                    {...inputStyles}
                    cursor={"pointer"}
                    onClick={() => handleSingleUser(user?.id)}
                >
                    Remove
                </Box>
            </Flex>

            
          ))) : (
            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
                <Spinner size="xl" color="blue.500" />
            </Flex>
            
          )
        }

            <Flex justifyContent="center" alignItems="center" mb={"2em"} display={"none"}>
              <Button
                bg="#07900C"
                {...btnStyle}
                disabled={selectedUsers?.length === 0} // Disable the button when no users are selected
                onClick={() => handleMultipleUsers(selectedUsers)}

              >
                Submit
              </Button>
            </Flex>

          </ModalBody>
        </ModalContent>
    </Modal>
    
    </>
  )
}

export default RemoveMembersModal